// extracted by mini-css-extract-plugin
export var grid = "link-tag-module--grid--988f4";
export var gridWithRowGap = "link-tag-module--grid--with-row-gap--50f26";
export var linkTag = "link-tag-module--link-tag--d91be";
export var maxWidthContainer = "link-tag-module--max-width-container--2c97e";
export var mt0 = "link-tag-module--mt-0--198d5";
export var mt1 = "link-tag-module--mt-1--9d46b";
export var mt2 = "link-tag-module--mt-2--92cde";
export var mt3 = "link-tag-module--mt-3--2fdcf";
export var mt4 = "link-tag-module--mt-4--0bc92";
export var mt5 = "link-tag-module--mt-5--08f8e";
export var mt6 = "link-tag-module--mt-6--94b19";
export var removeVisuallyHidden = "link-tag-module--remove-visually-hidden--f299d";
export var visuallyHidden = "link-tag-module--visually-hidden--7b958";
export var widgetBase = "link-tag-module--widget-base--0bbaf";